var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome"},[_c('h1',[_vm._v("成功啦！")]),_c('div',[_vm._v("您的订单已经完成了。")])])}]

export { render, staticRenderFns }